<template>
    <section>
      <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
      </div>
      <div v-show="!loading" class="content">
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div
                class="flash-message col-md-4 col-md-offset-4 text-center"
                v-if="flash"
              >
                <div class="alert" :class="'alert-' + flashType">
                  {{ flashMessage }}
                </div>
              </div>
            </div>
            <div id="details" class="row">
              <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.cityId)"
                    >
                      <label>City</label>
                      <select
                        required
                        name="cityId"
                        class="form-control"
                        :disabled="isCityDisable"
                        v-model="misCellaneous.cityId"
                        v-on:change="getCityId($event.target.value)"
                      >
                        <option value="" disabled>Select City Name</option>
                        <option v-for="cityId in citys" :value="cityId.id"
                          >{{ cityId.name }}
                        </option>
                      </select>
                      <field-messages
                        name="cityId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.expense)"
                    >
                      <label>Expense</label>
                      <input
                        type="text"
                        maxlength="25"
                        name="expense"
                        class="form-control"
                        required
                        v-model="misCellaneous.expense"
                        @input="expenseCheck()"
                        placeholder="Expense"
                        pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}"
                      />
                      <field-messages
                        name="expense"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Expense is a required field
                        </div>
                        <div slot="pattern">
                          Alphabets/Numbers are allowed.
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.expenseDate)"
                    >
                      <label for="dateAdded">Expense Date</label>
                      <date-picker
                        required
                        id="vMakeYear"
                        v-model="misCellaneous.expenseDate"
                        @change="misCellaneousDate()"
                        lang="en"
                        :not-after="afterDisable"
                        name="expenseDate"
                        input-class="form-control"
                        width="100%"
                        use-utc="true"
                        format="DD-MM-YYYY"
                      ></date-picker>
                      <field-messages
                        name="expenseDate"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Expense Date is a required field
                        </div>
                        <div slot="pattern">Expense Date is invalid</div>
                      </field-messages>
                    </validate>
                  </div>
  
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.expenseType)"
                    >
                      <label>Expense Type</label>
                      <select
                        required
                        name="expenseType"
                        class="form-control"
                        v-model="misCellaneous.expenseType"
                        @input="expenseTypeCheck()"
                      >
                        <option value="" disabled>Select Expense Type</option>
                        <option v-for="expenseType in expenseTypee">{{
                          expenseType
                        }}</option>
                      </select>
                      <field-messages
                        name="expenseType"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Expanse Type is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.amount)"
                    >
                      <label>Amount (INR)</label>
                      <input
                        maxlength="10"
                        min="0"
                        type="text"
                        name="amount"
                        class="form-control"
                        required
                        v-model="misCellaneous.amount"
                        placeholder="Amount"
                        pattern="\d{0,10}"
                      />
                      <field-messages
                        name="amount"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Amount is a required field</div>
                        <div slot="pattern">
                          Numbers are allowed.
                        </div>
                      </field-messages>
                    </validate>
                  </div>
  
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.segregationPlant)"
                    >
                      <label>Segregation Plant</label>
                      <select
                        required
                        name="segregationPlant"
                        class="form-control"
                        v-model="misCellaneous.segregationPlant"
                        @input="segergationPlantCheck()"
                      >
                        <option value="" disabled
                          >Select Segregation Plant</option
                        >
                        <option
                          v-for="segregationPlant in segregations"
                          :value="segregationPlant.id"
                          :key="segregationPlant.id"
                        >
                          {{ segregationPlant.name }}
                        </option>
                      </select>
                      <field-messages
                        name="segregationPlant"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Segregation Plant is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.receipt)"
                    >
                      <label>Receipt</label>
                      <input
                        type="file"
                        id="fileName"
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        name="receipt"
                        class="form-control"
                        required
                        @change="onDocumentchanged"
                      />
                      <field-messages
                        name="receipt"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Please upload less than 5mb Memo Picture
                        </div>
                      </field-messages>
                      <div
                        class="border p-2 mt-3"
                        v-if="
                          $route.params &&
                            $route.params._id != '0' &&
                            misCellaneous.receipt
                        "
                      >
                        <a v-bind:href="misCellaneous.receipt" target="_blank">
                          View
                        </a>
                      </div>
                    </validate>
                  </div>
                </div>
              </vue-form>
  
              <div class="col-sm-12 text-right">
                <router-link :to="{ name: 'miscellaneous' }">
                  <button class="mr-5 btn btn-default" type="button">
                    Cancel
                  </button>
                </router-link>
                <button
                  class="mr-2 btn gradientbt"
                  type="submit"
                  @click="createMisCellaneous"
                  :disabled="!(formstate.$dirty && formstate.$valid && this.docs)"
                  v-if="$route.params && $route.params._id == '0'"
                >
                  Save
                </button>
                <button
                  class="btn gradientbt mr-5"
                  type="submit"
                  @click="updateMisCallaneous"
                  :disabled="!((formstate.$dirty || isFileChange) && (formstate.$valid || isFileChange || isExpsneEnabled || isMiscellaneousEnabled || isExpsneTypeEnabled || isSegregationPlantEnabled))"
                  v-if="$route.params && $route.params._id && $route.params._id != '0'"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import axios from "axios";
  import store from "../../../store";
  import {
    formService,
    eventBus,
    misCellaneousService,
    fileService,
  } from "../../../services";
  import { EVENTS } from "../../../config";
  import { USER_ROLES } from "../../../config";
  import { mapState } from "vuex";
  
  export default {
    name: "miscellaneouscreate",
    changedFlag: "",
    data() {
      return {
        isCityDisable: false,
        isExpsneEnabled: false,
        isMiscellaneousEnabled: false,
        isExpsneTypeEnabled: false,
        isSegregationPlantEnabled: false,
        afterDisable: new Date(),
        ready: false,
        isFileChange: false,
        USER_ROLES: USER_ROLES,
        loading: false,
        flash: false,
        flashType: null,
        flashMessage: "",
        EVENTS: EVENTS,
        selectedValue: "Name",
        formstate: {},
        misCellaneous: {
          expenseType: "",
          cityId: "",
          segregationPlant: "",
        },
        oldMisCellaneous: {},
        MisCellaneousId: [],
        data: {},
  
        segregations: {},
        expenseTypee: ["Salary", "General Expenses"],
        citys: {},
        // driverPoints: {},
        docs: null,
      };
    },
    mounted: function() {
      this.getCityList();
    },
  
    methods: {
      fieldClassName: formService.fieldClassName,
  
      getCityList() {
        if (this.$store.state.auth.user.role.key === "cityAdmin") {
          const { _id, cityName } = this.$store.state.auth.user.cityId;
          this.citys = [{ id: _id, name: cityName }];
          this.misCellaneous["cityId"] = _id;
          this.getCityId(_id);
          this.isCityDisable = true;
          return;
        }
        this.loading = true;
        const params = {};
        let cityList = [];
        // params.page = 1;
        // params.limit = 999;
        this.$cityRepository
          .collectionCitysList(params)
          .then((res) => {
            this.loading = false;
            res.data.response.forEach((element) => {
              if (element.status === true) {
                cityList.push({
                  name: element.cityName,
                  id: element._id,
                });
              }
            });
            cityList.sort((item1, item2) => {
              return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
            });
            this.citys = cityList;
          })
          .catch((error) => {
            this.loading = false;
            console.error("citys.requestFunction-error:", error);
            this.$snotify.error("Get citys list failed", "Error!");
          });
      },
  
      getSegregationPlantList(cityId) {
        this.loading = true;
        const params = {};
        params.$select = ["_id", "plantName"];
        params.isActive = true;
        params.cityId = cityId;
        let segregationList = [];
        this.$segregationDataRepository
          .list(params)
          .then((res) => {
            this.loading = false;
            res.data.docs.forEach((element) => {
              // if (element.isActive === true && element.cityId === cityId) {
              segregationList.push({
                name: element.plantName,
                id: element._id,
              });
              // }
            });
            segregationList.sort((item1, item2) => {
              return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
            });
            this.segregations = segregationList;
          })
          .catch((error) => {
            this.loading = false;
            console.error("segregations.requestFunction-error:", error);
            this.$snotify.error("Get segregations list failed", "Error!");
          });
      },
      getMisCellaneous() {
        const params = {};
  
        return misCellaneousService
          .getById(this.$route.params._id)
          .then((response) => {
            this.getCityId(response.data.response.cityId._id);
            this.misCellaneous = response.data.response;
            this.misCellaneous["segregationPlant"] =
              response.data.response.segregationPlant._id;
            this.misCellaneous["cityId"] = response.data.response.cityId._id;
            this.oldMisCellaneous = _.cloneDeep(this.misCellaneous);
          })
          .catch((error) => {
            console.error("Fuel Expenses-error:", error);
            this.$snotify.error("Get Fuel Expenses failed", "Error!");
          });
      },
      onDocumentchanged(event) {
        const fileName = document.getElementById("fileName");
        if (
          ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
            event.target.files[0]["type"]
          )
        ) {
          if (event.target.files[0].size > 1024 * 1024 * 5) {
            this.$snotify.error("File Size max limit of 5 MB", "Error!");
            fileName.value = "";
            event.preventDefault();
            return;
          } else {
            this.docs = event.target.files[0];
            if (this.$route.params && this.$route.params._id != '0') {
              this.changedFlag = true;
            }
  
            if (this.docs) {
              this.isFileChange = true;
            } else {
              this.isFileChange = false;
            }
          }
        } else {
          this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
          fileName.value = "";
        }
      },
      async uploadDocument() {
        let docsArr = [];
  
        docsArr.push(this.docs);
  
        const response = await fileService.fileUpload(docsArr, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      },
  
      async createMisCellaneous() {
        this.loading = true;
  
        let uploadedFileLocation = await this.uploadDocument();
        if (uploadedFileLocation !== "") {
          this.misCellaneous.receipt = uploadedFileLocation[0].Location;
        }
        return misCellaneousService
          .addMiscellaneous(this.misCellaneous)
          .then((response) => {
            this.loading = false;
            this.flash = false;
            this.$snotify.success(
              `The Miscellaneous Expense has been added successfully.`
            );
            let docId = response._id;
            this.uploadDocument(docId);
            this.$router.push("/miscellaneous");
          })
          .catch((error) => {
            this.loading = false;
            this.$snotify.error(error, "Error!");
          });
      },
  
      clearChanges() {
        this.misCellaneous = _.cloneDeep(this.oldMisCellaneous);
        this.formstate._reset();
      },
      async updateMisCallaneous() {
        const id = this.$route.params._id;
        this.loading = true;
        this.data = {};
        this.data["cityId"] = this.misCellaneous["cityId"];
        this.data["expense"] = this.misCellaneous["expense"];
        this.data["expenseDate"] = this.misCellaneous["expenseDate"];
        this.data["expenseType"] = this.misCellaneous["expenseType"];
        this.data["amount"] = this.misCellaneous["amount"];
        // this.data["receipt"] = this.misCellaneous["receipt"];
        this.data["segregationPlant"] = this.misCellaneous["segregationPlant"];
        this.data["_id"] = this.$route.params._id;
        if (this.docs != null) {
          let uploadedFileLocation = await this.uploadDocument();
          if (uploadedFileLocation !== "") {
            this.data["receipt"] = uploadedFileLocation[0].Location;
          }
        } else {
          this.data["receipt"] = this.misCellaneous["receipt"];
        }
  
        return misCellaneousService
          .updateMisCallaneous(id, this.data)
          .then((response) => {
            this.loading = false;
            this.flash = false;
            this.formstate._reset();
            this.oldMisCellaneous = _.cloneDeep(this.misCellaneous);
            this.$snotify.success(`The Miscallaneous expense has been updated.`);
            this.$router.push("/miscellaneous");
          })
          .catch((error) => {
            this.loading = false;
            console.error("Fuel Expenses.Update MisCallaneous-error:", error);
            this.$snotify.error("Update MisCallaneous failed", "Error!");
            if (error.data.message.includes("must be one of")) {
              this.flash = true;
              this.flashType = "error";
              this.flashMessage =
                "That fuelExpenses name is not allowed. You must first update the list of allowed fuelExpenses names" +
                " in the appy client and server config.";
            }
          });
      },
      getCityId(cityId) {
        this.misCellaneous.segregationPlant = "";
        this.getSegregationPlantList(cityId);
      },
      
      expenseCheck(){
        this.isExpsneEnabled = true
      },
      misCellaneousDate(){
        this.isMiscellaneousEnabled = true
      },
      expenseTypeCheck(){
        this.isExpsneTypeEnabled = true
      },
      segergationPlantCheck(){
        this.isSegregationPlantEnabled = true
      }
    },
    created() {
      const promises = [];
      this.loading = true;
      // promises.push(this.getFuelExpenses());
      if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
        promises.push(this.getMisCellaneous());
      }
      Promise.all(promises)
        .then(() => {
          this.loading = false;
          this.ready = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    beforeDestroy() {},
  
    fieldClassName: function(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
  };
  </script>
  
  <style scoped>
  .required-field > label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
  }
  
  .form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
  }
  
  .has-danger {
    color: red;
  }
  
  .mt {
    margin-top: 7px;
  }
  
  .gradientbt {
    background: #0f6940;
    color: white;
  }
  
  .inputwrapper {
    position: relative;
  }
  
  .maps {
    position: absolute;
    top: 7px;
    right: 10px;
  }
  </style>
  


// WEBPACK FOOTER //
// misCellaneousCreate.vue?fee350ba